module.exports = __webpack_public_path__ + "static/media/openapi-partner-gold.d97d8fc2.png";